import React from 'react';
import { Link, useParams } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Package, Truck, CreditCard, Phone, CheckCircle, ArrowRight } from 'lucide-react';

const destinations = {
  'guadeloupe': {
    name: 'Guadeloupe',
    flag: '🇬🇵',
    region: 'DOM-TOM',
    description: 'Service de réexpédition de colis vers la Guadeloupe depuis la France métropolitaine.',
    longDescription: 'Vous habitez en Guadeloupe et souhaitez commander sur des sites français ? ISMParcel réceptionne vos colis à Béziers et les réexpédie vers Pointe-à-Pitre, Basse-Terre, Les Abymes et toute la Guadeloupe.',
    cities: ['Pointe-à-Pitre', 'Basse-Terre', 'Les Abymes', 'Le Gosier', 'Sainte-Anne'],
    priceFrom: '12,02',
    deliveryDays: '5-10',
    keywords: 'envoi colis Guadeloupe, réexpédition Guadeloupe, colis France Guadeloupe, shipping Guadeloupe, livraison Pointe-à-Pitre'
  },
  'martinique': {
    name: 'Martinique',
    flag: '🇲🇶',
    region: 'DOM-TOM',
    description: 'Service de réexpédition de colis vers la Martinique depuis la France métropolitaine.',
    longDescription: 'Commandez sur Amazon, Shein, Zalando depuis la Martinique ! ISMParcel reçoit vos colis en France et les réexpédie vers Fort-de-France, Le Lamentin, Schoelcher et toute la Martinique.',
    cities: ['Fort-de-France', 'Le Lamentin', 'Schoelcher', 'Sainte-Marie', 'Le Robert'],
    priceFrom: '12,02',
    deliveryDays: '5-10',
    keywords: 'envoi colis Martinique, réexpédition Martinique, colis France Martinique, shipping Martinique, livraison Fort-de-France'
  },
  'reunion': {
    name: 'La Réunion',
    flag: '🇷🇪',
    region: 'DOM-TOM',
    description: 'Service de réexpédition de colis vers La Réunion depuis la France métropolitaine.',
    longDescription: 'Depuis La Réunion, accédez à tous les sites e-commerce français. ISMParcel réceptionne vos achats à Béziers et les expédie vers Saint-Denis, Saint-Pierre, Saint-Paul et toute l\'île.',
    cities: ['Saint-Denis', 'Saint-Pierre', 'Saint-Paul', 'Le Tampon', 'Saint-André'],
    priceFrom: '12,02',
    deliveryDays: '5-10',
    keywords: 'envoi colis Réunion, réexpédition La Réunion, colis France Réunion, shipping Réunion, livraison Saint-Denis'
  },
  'guyane': {
    name: 'Guyane',
    flag: '🇬🇫',
    region: 'DOM-TOM',
    description: 'Service de réexpédition de colis vers la Guyane française.',
    longDescription: 'ISMParcel vous permet de commander sur tous les sites français depuis la Guyane. Nous réexpédions vers Cayenne, Kourou, Saint-Laurent-du-Maroni et toute la Guyane.',
    cities: ['Cayenne', 'Kourou', 'Saint-Laurent-du-Maroni', 'Matoury', 'Remire-Montjoly'],
    priceFrom: '12,02',
    deliveryDays: '5-10',
    keywords: 'envoi colis Guyane, réexpédition Guyane, colis France Guyane, shipping Cayenne, livraison Kourou'
  },
  'mayotte': {
    name: 'Mayotte',
    flag: '🇾🇹',
    region: 'DOM-TOM',
    description: 'Service de réexpédition de colis vers Mayotte depuis la France.',
    longDescription: 'Depuis Mayotte, commandez sur Amazon, Shein et tous les sites français. ISMParcel réexpédie vos colis vers Mamoudzou, Dzaoudzi et tout le département.',
    cities: ['Mamoudzou', 'Dzaoudzi', 'Koungou', 'Dembeni', 'Bandraboua'],
    priceFrom: '12,02',
    deliveryDays: '5-10',
    keywords: 'envoi colis Mayotte, réexpédition Mayotte, colis France Mayotte, shipping Mayotte, livraison Mamoudzou'
  },
  'senegal': {
    name: 'Sénégal',
    flag: '🇸🇳',
    region: 'Afrique de l\'Ouest',
    description: 'Service de réexpédition de colis vers le Sénégal depuis la France.',
    longDescription: 'ISMParcel vous permet d\'acheter sur les sites français et de recevoir vos colis au Sénégal. Livraison à Dakar, Thiès, Saint-Louis, Ziguinchor et dans tout le pays.',
    cities: ['Dakar', 'Thiès', 'Saint-Louis', 'Ziguinchor', 'Kaolack'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Sénégal, réexpédition Sénégal, colis France Sénégal, shipping Dakar, livraison Sénégal'
  },
  'cote-ivoire': {
    name: 'Côte d\'Ivoire',
    flag: '🇨🇮',
    region: 'Afrique de l\'Ouest',
    description: 'Service de réexpédition de colis vers la Côte d\'Ivoire depuis la France.',
    longDescription: 'Commandez en France et recevez en Côte d\'Ivoire ! ISMParcel expédie vers Abidjan, Bouaké, Yamoussoukro, San-Pédro et toutes les villes du pays.',
    cities: ['Abidjan', 'Bouaké', 'Yamoussoukro', 'San-Pédro', 'Daloa'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Côte d\'Ivoire, réexpédition Abidjan, colis France Côte d\'Ivoire, shipping Abidjan, livraison Côte d\'Ivoire'
  },
  'maroc': {
    name: 'Maroc',
    flag: '🇲🇦',
    region: 'Maghreb',
    description: 'Service de réexpédition de colis vers le Maroc depuis la France.',
    longDescription: 'ISMParcel expédie vos colis depuis la France vers le Maroc. Livraison à Casablanca, Rabat, Marrakech, Fès, Tanger et dans tout le royaume.',
    cities: ['Casablanca', 'Rabat', 'Marrakech', 'Fès', 'Tanger'],
    priceFrom: '23,79',
    deliveryDays: '5-10',
    keywords: 'envoi colis Maroc, réexpédition Maroc, colis France Maroc, shipping Casablanca, livraison Maroc'
  },
  'mali': {
    name: 'Mali',
    flag: '🇲🇱',
    region: 'Afrique de l\'Ouest',
    description: 'Service de réexpédition de colis vers le Mali depuis la France.',
    longDescription: 'Envoyez vos colis depuis la France vers le Mali avec ISMParcel. Livraison à Bamako, Sikasso, Ségou, Mopti et dans tout le pays.',
    cities: ['Bamako', 'Sikasso', 'Ségou', 'Mopti', 'Koutiala'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Mali, réexpédition Mali, colis France Mali, shipping Bamako, livraison Mali'
  },
  'cameroun': {
    name: 'Cameroun',
    flag: '🇨🇲',
    region: 'Afrique Centrale',
    description: 'Service de réexpédition de colis vers le Cameroun depuis la France.',
    longDescription: 'ISMParcel réexpédie vos achats français vers le Cameroun. Livraison à Douala, Yaoundé, Bafoussam, Garoua et dans tout le pays.',
    cities: ['Douala', 'Yaoundé', 'Bafoussam', 'Garoua', 'Bamenda'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Cameroun, réexpédition Cameroun, colis France Cameroun, shipping Douala, livraison Yaoundé'
  },
  'gabon': {
    name: 'Gabon',
    flag: '🇬🇦',
    region: 'Afrique Centrale',
    description: 'Service de réexpédition de colis vers le Gabon depuis la France.',
    longDescription: 'Commandez en France et recevez au Gabon ! ISMParcel expédie vers Libreville, Port-Gentil, Franceville et tout le pays.',
    cities: ['Libreville', 'Port-Gentil', 'Franceville', 'Oyem', 'Moanda'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Gabon, réexpédition Gabon, colis France Gabon, shipping Libreville, livraison Gabon'
  },
  'congo': {
    name: 'Congo',
    flag: '🇨🇬',
    region: 'Afrique Centrale',
    description: 'Service de réexpédition de colis vers le Congo depuis la France.',
    longDescription: 'ISMParcel réexpédie vos colis depuis la France vers le Congo. Livraison à Brazzaville, Pointe-Noire et dans tout le pays.',
    cities: ['Brazzaville', 'Pointe-Noire', 'Dolisie', 'Nkayi', 'Ouesso'],
    priceFrom: '35,19',
    deliveryDays: '7-15',
    keywords: 'envoi colis Congo, réexpédition Congo, colis France Congo, shipping Brazzaville, livraison Pointe-Noire'
  }
};

export default function DestinationPage() {
  const { slug } = useParams();
  const dest = destinations[slug];

  if (!dest) {
    return (
      <div className="min-h-screen bg-white">
        <Navbar />
        <div className="pt-24 pb-12 max-w-4xl mx-auto px-4 text-center">
          <h1 className="text-3xl font-bold mb-4">Destination non trouvée</h1>
          <Link to="/">
            <Button>Retour à l'accueil</Button>
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-600 to-blue-800 pt-24 pb-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center text-white">
            <span className="text-6xl mb-4 block">{dest.flag}</span>
            <h1 className="font-heading font-bold text-4xl md:text-5xl mb-4">
              Envoi de Colis vers {dest.name}
            </h1>
            <p className="text-xl text-blue-100 max-w-2xl mx-auto mb-6">
              {dest.description}
            </p>
            <div className="flex flex-wrap justify-center gap-4 mb-8">
              <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full">
                <span className="text-blue-200 text-sm">À partir de</span>
                <span className="text-2xl font-bold ml-2">{dest.priceFrom}€</span>
              </div>
              <div className="bg-white/10 backdrop-blur px-6 py-3 rounded-full">
                <span className="text-blue-200 text-sm">Délai</span>
                <span className="text-2xl font-bold ml-2">{dest.deliveryDays} jours</span>
              </div>
            </div>
            <Link to="/register">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-blue-50 font-bold">
                Créer mon compte gratuit
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Description */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-slate-900 mb-6 text-center">
            Réexpédition de colis France → {dest.name}
          </h2>
          <p className="text-lg text-slate-600 text-center mb-8">
            {dest.longDescription}
          </p>
          
          {/* Cities */}
          <div className="bg-white rounded-2xl p-6 shadow-sm">
            <h3 className="font-heading font-bold text-xl text-slate-900 mb-4">
              Villes de livraison en {dest.name}
            </h3>
            <div className="flex flex-wrap gap-2">
              {dest.cities.map((city) => (
                <span key={city} className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full text-sm font-medium">
                  {city}
                </span>
              ))}
              <span className="bg-slate-100 text-slate-600 px-4 py-2 rounded-full text-sm">
                + toutes les autres villes
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* How it works */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="font-heading font-bold text-3xl text-slate-900 mb-12 text-center">
            Comment envoyer un colis en {dest.name} ?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            {[
              { icon: Package, title: "1. Créez votre compte", desc: "Obtenez votre numéro client et notre adresse en France" },
              { icon: Truck, title: "2. Commandez en ligne", desc: "Sur Amazon, Shein, Zalando... avec notre adresse" },
              { icon: CreditCard, title: "3. Payez l'expédition", desc: "Nous vous notifions dès réception, payez en ligne" },
              { icon: CheckCircle, title: "4. Recevez en " + dest.name, desc: `Livraison en ${dest.deliveryDays} jours avec suivi` }
            ].map((step, i) => (
              <Card key={i} className="text-center">
                <CardContent className="pt-6">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
                    <step.icon className="w-6 h-6 text-blue-600" />
                  </div>
                  <h3 className="font-bold text-lg mb-2">{step.title}</h3>
                  <p className="text-slate-600 text-sm">{step.desc}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-blue-600">
        <div className="max-w-4xl mx-auto px-4 text-center text-white">
          <h2 className="font-heading font-bold text-3xl mb-4">
            Prêt à envoyer vos colis en {dest.name} ?
          </h2>
          <p className="text-blue-100 mb-8">
            Créez votre compte gratuitement et commencez à recevoir vos achats en {dest.name}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/register">
              <Button size="lg" className="bg-white text-blue-600 hover:bg-blue-50 font-bold">
                Créer mon compte
              </Button>
            </Link>
            <a href="tel:+33695148686">
              <Button size="lg" variant="outline" className="border-white text-white hover:bg-white/10">
                <Phone className="w-5 h-5 mr-2" />
                06 95 14 86 86
              </Button>
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export { destinations };
